export interface ErrorHandler<T = Error> {
  handle: (error: T, chain: ErrorHandlerChain) => void
}

export default class ErrorHandlerChain<T = Error> {
  private handlers: Array<ErrorHandler<T>>
  private index: number

  constructor(handlers: Array<ErrorHandler<T>>) {
    this.handlers = handlers ? handlers : []
    this.index = 0
  }

  async handle(error: T, chain: ErrorHandlerChain) {
    if (this.index == this.handlers.length) {
      throw error
    }

    const handler = this.handlers[this.index]

    this.index++

    return await handler.handle(error, chain)
  }
}
